<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton icon="fa-sync-alt" @click="load" />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <RFIDReaderDelay />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import RFIDReaderDelay from "@/components/reports/rfidreaderdelay/RFIDReaderDelay";
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "RFIDReaderDelays",

  components: {
    PageTitle,
    PageRowWrapper,
    RFIDReaderDelay,
    ActionButton,
  },

  methods: {
    async load() {
      await this.$store.dispatch("rfidreaderdelay/fetchAll");
    },
  },

  async mounted() {
    await this.load();
  },

  destroyed() {
    this.$store.commit("rfidreaderdelay/cleanState");
  },
};
</script>
